// Copyright (c) StrangeBee 2023

import { useLocalMessage } from '@Helpers/locale';
import { THButton } from '@Molecules/Inputs/THButton/THButton';
import { THPopConfirm } from '@Molecules/Inputs/THPopConfirm/THPopConfirm';
import { AuthEventList } from '@Organisms/AccountDetails/eventList';
import React, { ReactElement, useState } from 'react';

import './GlobalUserMFA.scss';

interface GlobalUserMFAProps {
    hasMFA?: boolean;
    authEventList: AuthEventList;
    userId: string;
}

export const GlobalUserMFA = ({ hasMFA, authEventList, userId }: GlobalUserMFAProps): ReactElement => {
    const i = useLocalMessage();

    const [disabledMFA, setDisabledMFA] = useState(false);

    return (
        <div className="global-user-mfa">
            {hasMFA && !disabledMFA ? (
                <>
                    <span>{i('general.yes')}</span>
                    <THPopConfirm
                        onConfirm={() => authEventList.onUnsetMFA(userId).then(() => setDisabledMFA(true))}
                        title={i('account.mfa.disable.confirm')}
                    >
                        <THButton type="link">{i('common.disable')}</THButton>
                    </THPopConfirm>
                </>
            ) : (
                i('general.no')
            )}
        </div>
    );
};
